export default __webpack_public_path__ + "static/media/landing_thumb_01.b557a758.svg";